export function padCodes(list, pick, size) {
  if (!Array.isArray(list)) {
    return Array(size).fill('');
  }

  return list
    .map(pick)
    .concat(Array(size).fill(''))
    .slice(0, size);
}

// Não inclui codEco, idade, tipoEco nem superficiecorporea.
// A cópia de laudo anterior preserva código, idade e tipo deste exame.
// A superfície é recalculada no form a partir do peso e da altura.
export default function mapEcoFormFields(source) {
  return {
    tipoLaudo: source.TIPOLAUDO || 'Alterado',
    sexo: source.Sexo || '',
    peso: source.PESOPAC || '',
    altura: source.ALTURAPAC || '',
    pressaosistolica: source.PS || '',
    frequenciacardiaca: source.FC || '',
    ecocardiograma: padCodes(source.obs, i => i.CODOBS, 10),
    septo: source.SEPTO || '',
    ppve: source.PPVE || '',
    dd: source.DD || '',
    ds: source.DS || '',
    fraejeBiplanar: source.FRAEJECBIPLA || '',
    fe3d: source.FRAEJE3D || '',
    achadosDescritivos: padCodes(source.achados, i => i.CODACHAVE, 10),
    contracaoSegmentar: padCodes(source.contraRegiao, i => i.CODCONTRASEG, 10),
    regiaoVE: padCodes(source.contraRegiao, i => i.CODREGIAO, 10),
    tempoEjecaoVE: source.TEVE || '',
    tempoAEMitral: source.IAEM || '',
    indiceCardiaco: source.EDC_VE || '',
    comentariosDiast: padCodes(source.avDiast, i => i.CODAVDIAST, 10),
    diamAE: source.DAE || '',
    indiceVolAE: source.VOL_AE || '',
    atrioEsq: padCodes(source.atrioEsq, i => i.CODAE, 5),
    valvaMitral: padCodes(source.valvaMitral, i => i.CODVM, 5),
    diamAO: source.DAVAO || '',
    diamSaidaVE: source.DVSVE || '',
    valvaAortica: padCodes(source.valvaAO, i => i.CODVAO, 5),
    aorta: padCodes(source.aorta, i => i.CODAORTA, 5),
    atrioDireito: padCodes(source.atrioDir, i => i.CODAD, 5),
    veiaCavaInferior: padCodes(source.veiaCavaInf, i => i.CODVCINF, 5),
    ventriculoDireito: padCodes(source.ventriDir, i => i.CODVD, 5),
    valvaTricuspide: padCodes(source.valvaTricu, i => i.CODVT, 5),
    valvaPulmonar: padCodes(source.valvaPulmo, i => i.CODVP, 5),
    diamAnelPulmonar: source.DAVP || '',
    pericardio: padCodes(source.pericardio, i => i.CODPERICARDIO, 10),
    areaMitral: source.DAM || '',
    gradienteMitral: source.GMVM || '',
    refluxoMitral: padCodes(source.refVM, i => i.CODREFVM, 5),
    pisaMitral: source.ORIFICIO_VM || '',
    volumeRegMitral: source.VOLUME_VM || '',
    areaAortica: source.AREA_AO || '',
    pisaAortica: source.PSAO || '',
    gmvao: source.GMVAO || '',
    gmvsve: source.GMVSVE || '',
    refluxoAortica: padCodes(source.refVAO, i => i.CODREFVAO, 5),
    gmvTric: source.GMVT || '',
    gpit: source.GPIT || '',
    refluxoTric: padCodes(source.refVT, i => i.CODREFVT, 5),
    refluxoPulm: padCodes(source.refVP, i => i.CODREFVP, 5),
    gradientePulm: source.GMVP || '',
    gradMitral: source.GMPM || '',
    refluxoProtMitral: padCodes(source.refluxoPM, i => i.CODREFPM, 5),
    intensidadeProtMitral: padCodes(source.refluxoPM, i => i.CODINTENSIDADE, 5),
    gradAortica: source.GMPAO || '',
    refluxoProtAortica: padCodes(source.refluxoPAO, i => i.CODREFPAO, 5),
    intensidadeProtAortica: padCodes(
      source.refluxoPAO,
      i => i.CODINTENSIDADE,
      5
    ),
    gradTricuspide: source.GMPT || '',
    refluxoProtTricuspide: padCodes(source.refluxoPT, i => i.CODREFPT, 5),
    intensidadeProtTricuspide: padCodes(
      source.refluxoPT,
      i => i.CODINTENSIDADE,
      5
    ),
    gradPulmonar: source.GMPP || '',
    refluxoProtPulmonar: padCodes(source.refluxoPP, i => i.CODREFPP, 5),
    intensidadeProtPulmonar: padCodes(
      source.refluxoPP,
      i => i.CODINTENSIDADE,
      5
    ),
    valvulopatia: padCodes(source.valvulopatia, i => i.CODVALVO, 5),
    intensidadeValv: padCodes(source.valvulopatia, i => i.CODINTENSIDADE, 5),
    predominanciaValv: padCodes(source.valvulopatia, i => i.CODPREDOMI, 5),
    protese: padCodes(source.protese, i => i.CODPROTESE, 5),
    descProtese: padCodes(source.protese, i => i.CDODESCRICAO, 5),
    predominanciaProtese: padCodes(source.protese, i => i.CODPREDOMI, 5),
    conSeg: padCodes(source.contraSeg, i => i.CODCONTRASEG, 5),
    regiao: padCodes(source.contraSeg, i => i.CODREGIAO, 5),
    conclusoes: padCodes(source.conclusoes, i => i.CODCONCLU, 10),
    intensidadeConclusoes: padCodes(
      source.conclusoes,
      i => i.CODINTENSIDADE,
      10
    ),
    observacoes: source.OBSERVACOES || '',
  };
}
